/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * This represents the type of permission entity. Example: Can be a Term or a Case Category
 **/
export var PermissionEntityType;
(function (PermissionEntityType) {
    PermissionEntityType["TERM"] = "TERM";
    PermissionEntityType["CASE_CATEGORY"] = "CASE_CATEGORY";
    PermissionEntityType["RESOLVER_GROUP"] = "RESOLVER_GROUP";
})(PermissionEntityType || (PermissionEntityType = {}));
